/* ==========================================================================
   Taana — wishlist.js
   Lightweight, device-local wishlist (no account needed). Disable in theme
   settings when a wishlist app is installed. Emits `taana:wishlist:change`
   { detail: { handles, handle, added } } so apps/analytics can integrate.
   ========================================================================== */
(() => {
  const Theme = (window.Theme = window.Theme || {});
  const KEY = 'taana:wishlist';

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  };
  const write = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* storage unavailable */ }
  };

  const wishlist = {
    get handles() { return read(); },
    has(handle) { return read().includes(handle); },
    toggle(handle) {
      const list = read();
      const idx = list.indexOf(handle);
      const added = idx === -1;
      if (added) list.unshift(handle);
      else list.splice(idx, 1);
      write(list.slice(0, 100));
      sync();
      document.dispatchEvent(new CustomEvent('taana:wishlist:change', { detail: { handles: list, handle, added } }));
      return added;
    },
  };
  Theme.wishlist = wishlist;

  function sync(root = document) {
    const list = read();
    root.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const on = list.includes(btn.dataset.wishlistToggle);
      btn.setAttribute('aria-pressed', String(on));
      const base = (btn.getAttribute('aria-label') || '').split(': ').slice(1).join(': ');
      if (base) btn.setAttribute('aria-label', `${on ? Theme.strings.wishlistRemove : Theme.strings.wishlistAdd}: ${base}`);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    const added = wishlist.toggle(btn.dataset.wishlistToggle);
    btn.classList.remove('is-bumped');
    void btn.offsetWidth;
    btn.classList.add('is-bumped');
    Theme.toast && Theme.toast(added ? Theme.strings.wishlistAdded : Theme.strings.wishlistRemoved);
  });

  // Keep state correct for cards injected later (recommendations, search, filters).
  let pending;
  const observer = new MutationObserver(() => {
    cancelAnimationFrame(pending);
    pending = requestAnimationFrame(() => sync());
  });
  const start = () => {
    sync();
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  // Sync across tabs
  window.addEventListener('storage', (e) => { if (e.key === KEY) sync(); });

})();
